module.exports = __webpack_public_path__ + "img/signature-white.aa40c235.webp";